import { Capacitor } from '@capacitor/core';
import { NativeFirebaseAuth } from './native';
import type { FirebaseAuthService, FirebaseWebConfig } from './types';
import { WebFirebaseAuth } from './web';

export type {
  AuthUser,
  FirebaseAuthService,
  FirebaseWebConfig,
  PhoneIntent,
  SentPhoneCode,
} from './types';

/** Native Firebase in the Capacitor apps, Firebase JS in the browser. */
export function createFirebaseAuth(config: FirebaseWebConfig): FirebaseAuthService {
  return Capacitor.isNativePlatform()
    ? new NativeFirebaseAuth(config)
    : new WebFirebaseAuth(config);
}
